import roundPortfolioTradeValue from 'src/components/PortfolioPage/utils/roundPortfolioTradeValue';

export default function computePortfolioTradeDelta(
	valueA: number | undefined,
	valueB: number | undefined
) {
	return roundPortfolioTradeValue((valueA ?? 0) - (valueB ?? 0));
}
